import React from 'react';
import styles from './applyform.module.css';

export default function ApplyFormPublisher() {


  return (
    <div className='contactForm'>
      <h3 className='contactForm__header'>Apply for a Publisher Account</h3>
      <p>Starting in 2026, we will be accepting publishers in two cohorts during the year. Applications received by <strong>April 1, 2026</strong> will be considered for distribution beginning in the fall of 2026, while applications received by <strong>October 1, 2026</strong> will be considered for distribution beginning in the spring of 2027.</p>
      <a className={styles.applyButton} href="https://olasubs.com/call/69b33300fbfa9d1d1d9a4f70/new-publisher-applications-spring-2027" target="_blank" rel="noopener noreferrer">Apply Here</a>
      <p className={styles.finePrint}>You may notice we're now taking applications through <a href='https://olasubs.com'>Ola</a>, a new submissions manager for small presses from the team at Asterism!</p>
    </div>
  )
}